import { Upload, Cpu, FileCheck } from "lucide-react";

const steps = [
  {
    icon: Upload,
    step: "01",
    title: "Upload Your Notes",
    description: "Take a photo of your handwritten notes or upload an existing image/PDF.",
  },
  {
    icon: Cpu,
    step: "02",
    title: "AI Processes",
    description: "Our AI extracts text, understands context, and generates the content you need.",
  },
  {
    icon: FileCheck,
    step: "03",
    title: "Download & Use",
    description: "Get your assignments, PPTs, or explanations ready to submit or study.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">How It Works</span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mt-2 mb-4">
            Three Simple Steps
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            From notes to polished content in under a minute.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connection line */}
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary/20 via-primary to-primary/20 -translate-y-1/2 z-0" />
            
            <div className="grid md:grid-cols-3 gap-8 relative z-10">
              {steps.map((step, index) => (
                <div key={step.step} className="text-center group">
                  <div className="relative mb-6 inline-block">
                    <div className="w-20 h-20 rounded-2xl gradient-primary flex items-center justify-center mx-auto shadow-glow group-hover:scale-110 transition-transform duration-300">
                      <step.icon className="w-8 h-8 text-primary-foreground" />
                    </div>
                    <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent text-gray-900 text-sm font-bold flex items-center justify-center">
                      {step.step}
                    </span>
                  </div>
                  <h3 className="text-xl font-semibold text-foreground mb-2">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {step.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
